import { render, staticRenderFns } from "./Booking_payment.vue?vue&type=template&id=570f94cc&"
import script from "./Booking_payment.vue?vue&type=script&lang=js&"
export * from "./Booking_payment.vue?vue&type=script&lang=js&"
import style0 from "./Booking_payment.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports